module.exports = __webpack_public_path__ + "img/CZ.f91e2000.svg";